import { render, staticRenderFns } from "./common-ad-top.vue?vue&type=template&id=053d48d6&scoped=true&"
import script from "./common-ad-top.vue?vue&type=script&lang=js&"
export * from "./common-ad-top.vue?vue&type=script&lang=js&"
import style0 from "./common-ad-top.vue?vue&type=style&index=0&id=053d48d6&lang=scss&scoped=true&"
import style1 from "./common-ad-top.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d48d6",
  null
  
)

export default component.exports